import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import OuterLink from '../../../atoms/OuterLink'

const Item = styled.li`
  line-height: 1em;
  margin: 10px 0 0;
  &:first-child {
    margin: 0;
  }
`

const ItemLink = styled(Link)`
  color: ${({ theme }) => theme.palette.font.link};
  font-size: 12px;
  text-decoration: none;
`

const ItemOuterLink = styled(OuterLink)`
  color: ${({ theme }) => theme.palette.font.link};
  font-size: 12px;
  text-decoration: none;
`

export default function MenuItem({ text, to }: { text: string; to: string }) {
  const Component = /^\/.+/.test(to) ? ItemLink : ItemOuterLink

  return (
    <Item>
      <Component to={to}>{text}</Component>
    </Item>
  )
}
